import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import lodash from "lodash";

import SelectTemplate from "./SelectTemplate";

class TextForm extends React.Component {
  render() {
    const {
      templates,
      options,
      selectedUser,
      message,
      onChangeSelectUsers,
      onChangeInput,
      onSelectTemplate
    } = this.props;

    return (
      <div>
        <div className="mb-15">
          <label htmlFor="text-select" >To *</label>
          <Select
            isMulti
            styles={{
              menuList: (base, state) => ({ ...base, maxHeight: 190 }),
              placeholder: (base) => ({ ...base, color: "#595959" })
            }}
            className="custom-react-select"
            value={selectedUser}
            options={options}
            inputId="text-select"
            ariaLabel="text-select"
            onChange={onChangeSelectUsers}
          />
        </div>

        <SelectTemplate
          data={lodash.filter(templates, { message_type: "Text" })}
          onSelect={onSelectTemplate}
        />

        <div>
          <label>Message *</label>
          <textarea
            cols="5"
            rows="3"
            maxLength={147}
            className="form-control"
            placeholder="Message to employees...Messages begin with 'YOUR FULL NAME via DigiQuatics: '"
            name="__message"
            value={message}
            onChange={onChangeInput}
          />
        </div>

        <span className="dark-grey-text">
          {147 - message.length} characters remaining
        </span>
      </div>
    );
  }
}

TextForm.propTypes = {
  templates: PropTypes.array,
  options: PropTypes.array,
  selectedUser: PropTypes.array,
  message: PropTypes.string,
  onChangeSelectUsers: PropTypes.func,
  onChangeInput: PropTypes.func,
  onSelectTemplate: PropTypes.func
};

export default TextForm;
